(function($) {


    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };


    $(document).ready(function() {
        if ( getUrlParameter('search_keywords') !== undefined) {
            $("input[name='filter_job_type[]']").each(function(){
                var value = getUrlParameter($(this).attr('id'));
                    if (value) {
                        $(this).prop('checked', true); // Checks it
                    } else {
                        $(this).prop('checked', false); // Unchecks it
                    }
            });
        }
    });
})( jQuery, window, document );
